import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = (theme: ExactTheme) => css`
  position: absolute;
  z-index: ${theme.zIndices.modals};
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
`;

export const container = (theme: ExactTheme) => css`
  position: relative;
  background: white;
  border-radius: ${theme.borderRadiusV2.primary};
  box-shadow: ${theme.shadowV2.primary};
  margin: 0 2vw;
`;

export const closeButton =
  ({ position }: { position: "inside" | "half-outside" }) =>
  (theme: ExactTheme) => {
    return [
      position === "inside" &&
        css`
          right: 9px;
          top: 9px;
        `,
      position === "half-outside" &&
        css`
          right: -16px;
          top: -16px;

          .CloseButton-background {
            box-shadow: ${theme.shadowV2.tertiary};
            background: white;
          }
          :hover {
            .CloseButton-background {
              //box-shadow: none;
            }
          }
        `,
      css`
        z-index: 100;
        position: absolute;
        cursor: pointer;
      `,
    ];
  };
